import { useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { RecoilRoot } from "recoil";

import "./style/index.css";
import { Layout, ConfigProvider, theme, message } from "antd";

import Footer from "./component/footer/Footer";
import { CustomBreadcrumb } from './component/breadcrumb';
// import { BreadcrumbProvider } from './context/BreadcrumbContext';
import { AppRoutes } from './routes';
import Header from './component/header/Header';
import { ScrollToTop } from './component/common';

import { ThemeProvider } from "styled-components";

import { postVisitLog } from './api/user';
import { useSyncHtmlLang } from './i18n';

message.config({
  top: 120,
  duration: 3,
});

const AppLayout = () => {
  const { token } = theme.useToken();
  const location = useLocation();
  useSyncHtmlLang();
  const isViewerPage = location.pathname.includes('/viewer');
  const isDemoConsultationPage = location.pathname.startsWith('/demo/consultation');
  const isMainPage = location.pathname === "/";
  const TopPadding = isDemoConsultationPage
    ? "40px"
    : location.pathname.startsWith('/post/')
      ? "5px"  // TopBar 제거로 40px 축소 (Post 내부 오프셋 55px과 합산되어 헤더 높이 확보)
      : "60px"; // 상단 고정 헤더(NavBar) 높이만큼

  if(isViewerPage) {
    message.config({
      top:50,
      duration:3,
    })
  }

  if(isDemoConsultationPage) {
    message.config({
      top: 8,
      duration: 3,
    });
  }

  return (
    <ThemeProvider theme={{ token }}>
      {!isViewerPage && <Header />}
      <Layout style={{ paddingTop: isViewerPage ? "0" : TopPadding, height: isViewerPage ? "100vh" : undefined, minHeight: isViewerPage ? undefined : "calc(100vh - 104px)", overflow: isViewerPage ? "hidden" : undefined, backgroundColor: "#fff" }}>
        {!isMainPage && <CustomBreadcrumb />}
        <AppRoutes />
      </Layout>
      {/* {!isViewerPage && <Footer />} */}
    </ThemeProvider>
  );
};

const App = () => {
  useEffect(() => {
    // 기존 sessionStorage 토큰 및 정리 (세션 → 로컬 마이그레이션, 안정화 후 제거)
    if (sessionStorage.getItem("atlas-access")) {
      sessionStorage.removeItem("atlas-access");
    }

    const hasVisited = sessionStorage.getItem("hasATLASVisited");
    if(!hasVisited) {
      postVisitLog().then(() => {
        sessionStorage.setItem("hasATLASVisited", "true");
      }).catch((error) => {
        console.error("방문자 로그 전송 실패:", error);
      });
    }
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#1890ff", // 서비스 메인 색상
          fontFamily: "'Roboto', sans-serif"
        },
      }}
    >
      <BrowserRouter>
        <ScrollToTop />
        <RecoilRoot>
          {/* <BreadcrumbProvider> */}
          <AppLayout />
          {/* </BreadcrumbProvider> */}
        </RecoilRoot>
      </BrowserRouter>
    </ConfigProvider>
  );
};

export default App;
